import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ResetPasswordService } from '../services/resetPassword.service';
import { Subscription, timer } from 'rxjs';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css'],
  standalone: false
})
export class ForgotPasswordComponent {

  errormsg: string = "";
  msg: string = "";

  username: string = "";
  email: string = "";

  private subcriptionTimer!: Subscription;

  constructor(
    private passwordService: ResetPasswordService,
    private router: Router
  ) { }

  ngOnInit() {
    this.msg = "";
    this.errormsg = "";
    this.username = "";
    this.email = "";
  }

  ngOnDestroy(): void {
    this.subcriptionTimer?.unsubscribe();
  }

  response: any;

  resetPassword() {
    this.msg = "";
    this.errormsg = "";
    this.passwordService.resetPassword(this.username, this.email).subscribe(response => {
      this.response = (response)

      if (this.response == "Password updated and Email sent.") {
        this.msg = "An Email has been sent.";
        this.subcriptionTimer = timer(3000).subscribe(() => {
          this.router.navigateByUrl('/home');
        }); // 3 seconds delay in redirecting to the home page.
      } else {
        this.errormsg = this.response;
      }
    });
  }
}
